<template>
  <div class="footer" v-if="footerShow">
    <div class="w-full flex justify-center">
      <router-link to="/home"><img :src="require('../../assets/web/foot-logo.png')" alt="Home" /></router-link>
    </div>
    <div style="display: flex; justify-content: center; align-items: center; margin-top: 20px">
      <div @click="handleDown(1)">
        <img style="width: 130px; margin-right: 20px; cursor: pointer" src="https://sidequest-1307226287.cos.eu-frankfurt.myqcloud.com/mail/Apple.png" alt="" loading="lazy" />
      </div>
      <div @click="handleDown(2)">
        <img style="width: 120px; cursor: pointer" src="https://sidequest-1307226287.cos.eu-frankfurt.myqcloud.com/mail/google2.png" alt="" loading="lazy" />
      </div>
    </div>
    <div class="img-list">
      <a href="https://twitter.com/SideQuest_Hub" target="_blank"><img :src="require('../../assets/web/foot1.png')" alt="" /></a>
      <a href="https://www.instagram.com/sidequest_hub/" target="_blank"><img :src="require('../../assets/web/foot2.png')" alt="" /></a>
      <a href="https://www.tiktok.com/@sidequest_hub/" target="_blank"><img :src="require('../../assets/web/foot6.png')" alt="" /></a>
      <a href="https://discord.gg/4DdYP3nTxe" target="_blank"><img :src="require('../../assets/web/foot7.png')" alt="" /></a>
      <img :src="require('../../assets/web/foot4.png')" alt="" />
    </div>
    <!--    <div>-->
    <!--      <a target="_blank" href="https://apps.apple.com/us/app/sidequest-hub/id1614945163">App Store Download</a>-->
    <!--      <a target="_blank" href="https://play.google.com/store/apps/details?id=uk.co.sidequest.wy">Android Download</a>-->
    <!--    </div>-->
    <div class="list">
      <div>
        <p>CUSTOMER AREA</p>
        <ul>
          <li><router-link to="/about">About Us</router-link></li>
          <li style="cursor: pointer" @click="handleContact">Contact Us</li>
          <li><router-link :to="{ path: '/about', query: { id: 'third' } }">Student Society</router-link></li>
          <li>
            <a :href="'/static/pdfjs/web/viewer.html?file=/static/policy/Return-and-Refund-Policy.pdf'" target="_blank">Return & Refund</a>
          </li>
          <li>
            <a :href="'/static/pdfjs/web/viewer.html?file=/static/policy/SideQuest-Terms-of-Service.pdf'" target="_blank">Terms & Conditions</a>
          </li>

          <li>
            <a :href="'/static/pdfjs/web/viewer.html?file=/static/policy/User_Agreement.pdf'" target="_blank">User Agreement</a>
          </li>

          <li><router-link to="/faqList">FAQ</router-link></li>
        </ul>
      </div>
      <div>
        <p>OUR STORE</p>
        <ul>
          <li>
            <router-link to="/store/5">Charing Cross</router-link>
          </li>
        </ul>
      </div>
      <div>
        <p>SUPPORTED GAMES</p>
        <ul>
          <li>
            <a :href="'https://playvalorant.com/'" target="_blank">VALORANT</a>
          </li>
          <li>
            <a :href="'https://www.leagueoflegends.com/'" target="_blank">League of Legends</a>
          </li>
          <li>
            <a :href="'https://www.counter-strike.net'" target="_blank">Counter-Stike: Global Offensive</a>
          </li>
          <li>
            <a :href="'https://www.epicgames.com/fortnite'" target="_blank">Fortnite</a>
          </li>
          <li>
            <a :href="'https://www.ea.com/en-gb/games/apex-legends'" target="_blank">Apex Legends</a>
          </li>
          <li>
            <a :href="'https://na.battlegrounds.pubg.com/'" target="_blank">PUBG: BATTLEGROUNDS</a>
          </li>
          <li>
            <a :href="'https://www.roblox.com'" target="_blank">Roblox</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="statistics-list">
      <div>
        <p>80,000+</p>
        <p>Active users playing on platforms provided by the app</p>
      </div>
      <div>
        <p>300+</p>
        <p>Tournaments hosted since 2021</p>
      </div>
      <div>
        <p>1,000,000+</p>
        <p>Hours played collectively</p>
      </div>
      <div>
        <p>£50k+</p>
        <p>Paid as a prizepool on our platform, giveaways and events</p>
      </div>
    </div>
    <!-- <div style="display: flex; justify-content: center; align-items: center">
      <div
        style="
          font-size: 36px;
          color: #090916;
          font-weight: bold;
          text-align: left;
        "
      >
        Partnered <br />
        with
      </div>
      <a href="https://ukcsgo.com/">
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 425.2 425.2" style="width: 220px">
        <path class="cls-2" d="M177.95,135.84v154.96h-97.98c-13.53,0-25.79-5.48-34.65-14.35-8.87-8.87-14.35-21.12-14.35-34.65v-105.96h49v86.99c0,10.47,8.5,18.98,18.98,18.98h30v-105.96h49Z"/>
        <polyline class="cls-2" points="177.95 242.51 218.48 290.8 267.47 290.8 202.44 213.32 267.47 135.84 218.48 135.84 177.95 184.13"/>
        <polygon class="cls-1" points="185.36 165.14 209.95 135.84 185.36 135.84 185.36 165.14"/>
        <polygon class="cls-1" points="185.36 290.8 209.95 290.8 185.36 261.5 185.36 290.8"/>
        <g>
          <path class="cls-1" d="M280.21,145.85l-56.64,67.48,47.49,56.58h0c.12.67.29,1.32.52,1.99-.82,3.24-1.64,6.44-2.43,9.59l-57.2-68.16,61.28-73.04,3.73-4.44h11.61l-8.38,10.01Z"/>
          <path class="cls-1" d="M246.45,213.32l30.41,36.22c-.88,1.59-1.65,3.35-2.06,5.29-.36,1.7-.75,3.2-1.26,4.61l-38.7-46.12,61.28-73.04,3.73-4.44h11.61l-5.28,6.31-3.1,3.69-1.6,1.9c-1.56.67-3.02,1.63-4.37,2.86-2.82,2.58-4.86,5.77-6.16,9.69l-44.5,53.02Z"/>
          <path class="cls-1" d="M303.09,280.8l8.38,10.01h-11.61l-3.73-4.45-6.63-7.89c.23-.68.5-1.38.83-2.1,1.95-1.21,3.32-3.15,4.11-5.79,0-.02,0-.05.02-.07l8.63,10.29Z"/>
          <path class="cls-1" d="M283.17,196.83l-13.85,16.49,13.37,15.93c-.08.5-.15,1-.21,1.5-.09.67-.21,1.36-.32,2.1-.41,2.5-.88,5.29-.33,8.38-.08.19-.16.37-.24.57l-23.88-28.47,25.31-30.17c-.15,1.83-.36,3.72-.66,5.71l-.06.41c-.15.91-.3,1.95-.35,3.07-.06,1.44.18,3.11,1.22,4.48Z"/>
          <path class="cls-1" d="M325.48,290.81h-2.75l-3.73-4.45-20.8-24.79c.93-2.34,1.25-4.62.96-6.92-.03-.21-.08-.59.53-1.15.52-.48,1.16-1.11,1.77-1.9l23.05,27.47c-.31,1.21-.53,2.37-.74,3.46-.13.65-.25,1.3-.39,1.96-.54,2.49.26,4.81,2.1,6.31Z"/>
          <path class="cls-1" d="M284.47,208.7c.06.49.11.98.16,1.46-.9.87-1.6,1.94-2.02,3.14-.22.64-.35,1.29-.41,1.95l-1.61-1.92,3.88-4.63Z"/>
          <path class="cls-1" d="M322.62,259.08c.17,1.59.36,3.36.73,5.2l-16.88-20.11c.2-.68.33-1.39.4-2.15.19-2.21,1.17-4.49,2.21-6.89.16-.37.32-.74.48-1.13l12.97,15.44c-.46,1.23-.62,2.59-.46,4.02.11.96.2,1.92.29,2.89.08.91.17,1.81.26,2.72Z"/>
        </g>
        <path class="cls-2" d="M291.7,195.23c-1.29-.29-2.32-.52-3.35-.76-1.28-.3-1.55-.58-1.49-1.91.04-.99.21-1.98.36-2.96.49-3.26.8-6.54.88-9.84.04-1.56.24-1.76,1.78-1.92,1.19-.12,2.39-.23,3.58-.37.83-.1,1.15-.53,1.06-1.41-.32-3.11-.5-6.24-.04-9.35.7-4.76,2.29-9.12,5.95-12.48,2.01-1.84,4.37-2.8,7.11-2.79.89,0,1.7.19,2.41.75.34.27.68.49,1.1.15.39-.31.56-.69.4-1.18-.09-.29-.2-.58-.3-.88-1.67-5.11.31-11.3,4.62-14.47,3.69-2.72,8.49-2.93,12.4-.53,1.29.79,2.57,1.6,3.95,2.22.7.31,1.08.85,1,1.63-.05.54.16,1.01.34,1.49.82,2.15,1.19,4.36.87,6.67-.22,1.54-1.01,2.47-2.53,2.87-1.54.41-1.56.52-1.39,2.08.04.38.07.75.1,1.13.13,1.47.47,1.77,1.89,1.53,1.69-.28,3.28-1.01,4.99-1.24.53-.07.62-.58.73-1.02.23-.89.46-1.78.72-2.78.65.39.63.95.66,1.41.04.87.35,1.43,1.26,1.59.22.04.54.16.61.33.43,1.04,1.32.92,2.17.92,9.96,0,19.92.01,29.88.02.72,0,1.52-.11,1.54.99,0,.17.15.32.34.33.24.01.41-.14.45-.34.07-.33.11-.68.11-1.02.02-1.17,0-2.34.03-3.5,0-.41.06-.91.63-.88.48.02.54.47.55.86.02.93.02,1.85.03,2.78,0,.53.09,1.03.44,1.45.2.24.42.5.78.34.96-.42.96.28,1,.86.1,1.42.08,1.44,1.51,1.45,2.1.02,4.19,0,6.29,0,.65,0,1.31-.02,1.89-.39.24-.15.52-.23.79-.13,1.31.44,2.66.26,3.99.28.73.02,1.18.23,1.17,1.06,0,.82-.36,1.18-1.19,1.18-1.3.01-2.61.08-3.91.13-.14,0-.29.02-.41-.03-2.83-1.12-5.76-.46-8.65-.48-1.66,0-3.29.73-4.99.21-.38-.12-.55.2-.59.54-.11.94-.75,1.12-1.55,1.12-3.57,0-7.14.01-10.72,0-1.63,0-2.94.45-3.75,2-.5.96-1.33,1.68-2.23,2.26-1.02.66-1.24,1.54-1.08,2.65.23,1.64.64,3.23,1.02,4.84.37,1.57.37,1.62-1.12,2.03-.87.24-1.35.74-1.51,1.61-.23,1.25-.46,2.5-.7,3.75-.34,1.69-1.15,3.04-2.63,4.02-.88.59-1.68,1.31-2.45,2.04-.91.86-2.21.88-3.21,1.55-.06.04-.22,0-.28-.06-1.01-.95-2.38-.78-3.57-1.16-3.14-.99-5.98-2.6-8.83-4.18q-1.77-.98-2.25.95-.39,1.52.92,2.28c1.37.79,1.98,2.01,2.11,3.56.24,2.9-.3,5.75-.49,8.63-.06.89-.12,1.78-.13,2.67-.02,2.01-.83,3.74-1.91,5.36-.6.9-1.51.82-2.42.58-2.01-.54-2.63.1-2.32,2.2.3,2.01.94,3.76,2.38,5.32,4.58,4.96,7.25,11.04,9.67,17.24.42,1.09.85,2.18,1.23,3.28.29.83.64,1.59,1.45,2.04.17.1.41.28.41.43.06,1.73,1.15,3.2,1.2,4.94.12,4.73-.43,9.39-1.17,14.04-.24,1.48-.3,2.93.02,4.39.49,2.25.04,4.32-.66,6.52-.99,3.09-1.03,6.49.17,9.51.99,2.49,3.17,4.36,5.21,6.15.39.34.92.46,1.41.61,1.32.41,2.56.98,3.77,1.66.54.31.87.73,1,1.35.45,2.12-.03,2.72-2.17,2.91-2.5.22-5.01.13-7.52.14-1.28,0-2.55-.17-3.75-.61-2.27-.84-4.58-1.13-6.98-.71-.93.16-1.85-.02-2.72-.4-.79-.34-1.14-.89-.94-1.8.57-2.61.87-5.28,1.91-7.79.51-1.22.25-2.58.19-3.88-.08-1.65-.24-3.29-.37-4.93-.02-.2-.01-.43-.1-.6-1.56-3.07-1.96-6.42-2.32-9.77-.2-1.88-.35-3.76-.56-5.64-.11-1.01.09-1.95.71-2.72.6-.74.84-1.53.85-2.46.01-.79.1-1.58.24-2.36.22-1.28-.52-2.15-1.22-3.04-.28-.36-.68-.26-1.05-.19-2.03.36-3.59-.24-4.76-2.04-2.08-3.2-4.28-6.31-6.38-9.49-.56-.85-1.19-1.35-2.25-1.29-1.09.07-1.91-.45-2.44-1.42-.26-.48-.51-.97-.81-1.44-.21-.33-.21-.92-.73-.87-.4.04-.48.55-.59.9-.36,1.1-.92,2.05-1.75,2.87-.66.65-1.18,1.45-1.54,2.31-1.35,3.22-2.93,6.36-3.24,9.93-.13,1.49-.69,2.79-2.1,3.58-.63.35-.98.94-1.24,1.6-.49,1.24-1.29,2.2-2.28,3.12-1.53,1.41-2.34,3.27-2.07,5.36.2,1.61-.08,3.07-.66,4.52-.4.99-.8,1.97-1.27,2.93-1.03,2.1-1.97,4.23-2.63,6.48-.43,1.46-1.11,2.74-2.65,3.33-.34.13-.53.43-.69.74-1.91,3.72-2.93,7.62-2.22,11.83.1.57.3,1.13.45,1.69.15.56.36,1.12.45,1.69.37,2.34.01,2.74-2.34,2.93-2.54.2-5.06.3-7.6-.1-1.14-.18-1.66-.76-1.86-1.85-.33-1.73-.2-3.42.22-5.1.96-3.87,1.94-7.73,2.93-11.59.22-.85.1-1.6-.2-2.47-.65-1.89-.7-3.98.3-5.71,1.6-2.75,2.4-5.64,3.07-8.72.64-2.96,2.45-5.55,4.26-8.04,1.24-1.71,2.12-3.67,2.87-5.66.13-.34.16-.77.07-1.12-.8-3.29.15-6.48.55-9.7.25-2.04.63-4.07.97-6.1.09-.53-.03-.97-.26-1.47-.74-1.62-1.11-3.31-.5-5.08.13-.37.18-.69-.04-1.07-1.02-1.8-.29-3.89,1.62-4.67.73-.3.53-.89.5-1.4-.15-2.47-.5-4.92-.85-7.37-.28-1.94-.41-3.89-.31-5.85.02-.37-.17-1.06.67-.67.16.08.3-.06.28-.2-.18-1.32.92-1.42,1.71-1.81.11-.06.21-.16.55-.44ZM349.47,165.01c-.07-.34-.14-.67-.2-1.01-.15-.86-.65-1.21-1.52-1.17-.91.05-1.84.39-1.84,1.29,0,1.1-.65,1.4-1.35,1.81-.36.2-.72.4-1.07.61-.74.44-.96,1.02-.52,1.82.43.78.86,1.57,1.23,2.38.36.78.7.85,1.36.25,1.66-1.52,2.54-3.56,3.77-5.37.11-.16.1-.39.15-.6Z"/>
        </svg>
      </a>

    </div> -->
    <p style="padding-top: 40px">Copyright © 2019 - 2025 Ocean Monster Charing Cross LTD,All rights reserved | Play your way</p>
  </div>

  <el-dialog class="dialog-contact-us" v-model="dialogVisible" append-to-body center>
    <DialogJoinUs @onClose="dialogVisible = false" />
  </el-dialog>

  <el-dialog v-model="downShow" width="20%" append-to-body center>
    <div class="content flex justify-center items-center flex-col" v-if="downType === 2">
      <p style="font-size: 20px; margin-bottom: 20px">
        {{ downType === 2 ? 'Android' : 'IOS' }}
      </p>
      <img style="width: 160px" src="../../assets/android.png" alt="" />
      <button :style="{ fontSize: '0.875rem', color: '#ffd40e', backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }" v-if="downType === 2" @click="redirectToAndroid">Download Now</button>
    </div>
    <div class="content flex justify-center items-center flex-col" v-else>
      <p style="font-size: 20px; margin-bottom: 20px">
        {{ downType === 2 ? 'Android' : 'IOS' }}
      </p>
      <img style="width: 160px" src="../../assets/ios.png" alt="" />
      <button :style="{ fontSize: '0.875rem', color: '#ffd40e', backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }" v-if="downType === 1" @click="redirectToIOS">Download Now</button>
    </div>

    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="downShow = false">OK</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import DialogJoinUs from '@/components/web/joinUs/dialog-join-us'

export default {
  name: 'footer-web',
  components: {
    DialogJoinUs
  },
  methods: {
    redirectToAndroid() {
      window.location.href = 'https://play.google.com/store/apps/details?id=uk.co.sidequest.wy'
    },
    redirectToIOS() {
      window.location.href = 'https://apps.apple.com/gb/app/sidequest-gamers-hub/id6478599943'
    }
  },
  setup() {
    const dialogVisible = ref(false)
    const downShow = ref(false)
    const footerShow = ref(true)
    const downType = ref(1)
    const handleContact = () => {
      dialogVisible.value = true
    }

    const router = useRouter()
    watch(
      router.currentRoute,
      (v) => {
        footerShow.value = v.meta.name !== 'shpw'
      },
      { immediate: true }
    )
    const handleDown = (v) => {
      downType.value = v
      downShow.value = true
    }
    return {
      dialogVisible,
      footerShow,
      handleContact,
      downShow,
      downType,
      handleDown
    }
  }
}
</script>

<style scoped lang="scss">
@use '@/styles/base' as *;

.footer {
  @include container-base;
  background: #bbbbbb;
  padding-top: 48px;
  padding-bottom: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .img-list {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 45px 0;

    img {
      padding: 0 16px;
    }
  }

  .list {
    width: 100%;
    max-width: 1024px;
    display: flex;
    justify-content: space-around;
    text-align: left;
    padding: 45px 0 90px;

    @include media('<desktop') {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 24px;
    }
    @include media('<tablet') {
      grid-template-columns: 1fr;
    }

    a {
      color: black;
    }
    p:first-child {
      font-weight: bold;
      padding-bottom: 20px;
    }

    ul {
      line-height: 30px;
    }
  }

  .statistics-list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 16px;
    justify-content: space-between;
    padding: 0 20px 80px;

    @include media('<wide') {
      grid-template-columns: 1fr 1fr;
    }

    @include media('<tablet') {
      grid-template-columns: 1fr;
      padding: 0 0 80px;
    }

    div {
      text-align: left;

      p:first-child {
        font-weight: bold;
        font-size: 32px;
      }
    }
  }
}
</style>
<style>
.cls-1 {
  fill: #763433;
}

.cls-1,
.cls-2 {
  stroke-width: 0px;
}

.cls-2 {
  fill: #243469;
}
</style>
